import React from 'react';
import { CheckCircleOutlined, LoadingOutlined } from '@ant-design/icons';

export type CancellationFeeSaveStage =
  | 'idle'
  | 'saving-cancellation-fee'
  | 'saving-offering'
  | 'completed';

const SAVE_STEPS: { key: CancellationFeeSaveStage; label: string }[] = [
  { key: 'saving-cancellation-fee', label: 'Saving cancellation fee' },
  { key: 'saving-offering', label: 'Saving offering' },
  { key: 'completed', label: 'Completed' },
];

interface Props {
  stage: CancellationFeeSaveStage;
}

const CancellationFeeSaveProgress: React.FC<Props> = ({ stage }) => {
  if (stage === 'idle') return null;

  const activeIndex = SAVE_STEPS.findIndex(step => step.key === stage);

  return (
    <ul className="cancellation-fees-save-steps" aria-live="polite">
      {SAVE_STEPS.map((step, index) => {
        const isVisible = stage === 'completed' || index <= activeIndex;
        if (!isVisible) return null;

        const isComplete = stage === 'completed' || index < activeIndex;
        const isActive = step.key === stage && stage !== 'completed';

        return (
          <li
            key={step.key}
            className={[
              'cancellation-fees-save-step',
              'is-visible',
              isComplete ? 'is-complete' : '',
              isActive ? 'is-active' : '',
            ]
              .filter(Boolean)
              .join(' ')}
            style={{ animationDelay: `${index * 120}ms` }}
          >
            <span className="cancellation-fees-save-step-icon" aria-hidden="true">
              {isComplete ? (
                <CheckCircleOutlined />
              ) : isActive ? (
                <LoadingOutlined spin />
              ) : (
                <span className="cancellation-fees-save-step-dot" />
              )}
            </span>
            <span className="cancellation-fees-save-step-label">{step.label}</span>
          </li>
        );
      })}
    </ul>
  );
};

export default CancellationFeeSaveProgress;